function handleFormatQuantityTolerance(value) {
    if (value === 0 || value === '0') return "Keine Einschränkung";
    value = value + '';
    value = value.replace(/\./g, ",");
    return value + ' %';
}

export default handleFormatQuantityTolerance;